import { Card } from "components/atoms/Card";
import { ApiKey } from "components/molecules/ApiKey";

export const ApiKeyModule = () => {
  return (
    <Card
      className="!p-0 h-fit overflow-hidden"
      headerClassName="p-4"
      icon="key"
      title="API Key"
      subtitle="Generate an API key to integrate with your applications."
      bodyClassName="flex flex-col md:flex-row h-full w-full px-10 pb-10 gap-4 overflow-scroll"
    >
      <div className="flex flex-col w-full border border-gray-700 p-8 rounded-xl gap-10">
        <ApiKey showSmall />
      </div>
    </Card>
  );
};
